<script>
import { layoutComputed, authMethods } from '@/state/helpers'
import axios from 'axios'

export default {
  data() {
    return {
      loading: false,
      pagetitle: 'Home',
      credentials: {
        username: '',
        password: '',
        authType:'Local Authentication',
      },
      showPassword: false,
      error: '',
    }
  },
  computed: {
    ...layoutComputed,
  },
  methods: {
    ...authMethods,
    login() {
      if (!this.validateRequest()) return

      this.loading = true
      const url = `${window.authUrl}/signin/form`
      const params = new URLSearchParams(this.credentials)

      axios
        .post(url, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((response) => {
          let user = response.data
          this.authLogin(user)
          const redirectPath = this.$route.query.redirectFrom || '/'
          window.location.href = redirectPath
        })
        .catch((error) => {
          const status = error.response?.status

          if (status === 400) {
            this.error = 'Invalid credentials.'
          } else {
            this.error = 'Something went wrong. Please try again later.'
          }
          console.error('Error:', this.error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    togglePassword() {
      this.showPassword = !this.showPassword
    },
    validateRequest() {
      this.error = ''
      if (!this.credentials.username) {
        this.error = 'Username field is required'
        return false
      }
      if (!this.credentials.password) {
        this.error = 'Password field is required'
        return false
      }
      return true
    },
  },
  mounted() {
    document.body.setAttribute('data-layout-mode', this.layoutMode)
    document.body.setAttribute('data-sidebar', this.sidebarColor)
  },
}
</script>

<style scoped>
.auth-page {
  position: absolute;
  z-index: 10000;
  background-color: #040622;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

body[data-sidebar='dark'] {
  background: #040622;
}

.mdi-loading {
  right: 15px;
}
</style>

<template>
  <div class="auth-page">
    <div class="container-fluid p-0">
      <div class="row g-0 align-items-center">
        <div class="col-xxl-4 col-lg-4 col-md-6">
          <div class="row justify-content-center g-0">
            <div class="col-xl-9">
              <div class="p-4">
                <div class="card mb-0">
                  <div class="card-body">
                    <div class="auth-full-page-content rounded d-flex p-3 my-2">
                      <div class="w-100">
                        <div class="d-flex flex-column h-100">
                          <div class="mb-4 mb-md-5">
                            <router-link to="/" class="d-block auth-logo">
                              <img src="@/assets/images/eze_nms_logo.svg" alt="" height="22" class="auth-logo-dark me-start" />
                              <img src="@/assets/images/eze_nms_logo.svg" alt="" height="22" class="auth-logo-light me-start" />
                            </router-link>
                          </div>
                          <div class="auth-content my-auto">
                            <form @submit.prevent="login()">
                              <div class="alert alert-danger" v-show="error">{{ error }}</div>
                              <div class="form-floating form-floating-custom mb-4">
                                <select class="form-select" id="select-authtype" v-model="credentials.authType">
                                  <option value="Local Authentication">Local Authentication</option>
                                  <option value="Ezemanage">Ezemanage</option>
                                </select>
                                <label for="select-authtype">Authentication Type</label>
                                <div class="form-floating-icon">
                                  <eva-icon name="menu-outline"></eva-icon>
                                </div>
                              </div>

                              <div class="form-floating form-floating-custom mb-4">
                                <input type="text" class="form-control" id="input-username" placeholder="Username" v-model="credentials.username" />
                                <label for="input-username">Username</label>
                                <div class="form-floating-icon">
                                  <eva-icon name="person-outline"></eva-icon>
                                </div>
                              </div>

                              <div class="form-floating form-floating-custom mb-4 auth-pass-inputgroup">
                                <input :type="showPassword ? 'text' : 'password'" class="form-control pe-5" id="password-input" placeholder="Password" v-model="credentials.password" />

                                <button type="button" class="btn btn-link position-absolute h-100 end-0 top-0" id="password-addon" @click="togglePassword()">
                                  <i class="mdi mdi-eye-outline font-size-18 text-muted"></i>
                                </button>
                                <label for="password-input">Password</label>
                                <div class="form-floating-icon">
                                  <eva-icon name="lock-outline"></eva-icon>
                                </div>
                              </div>

                              <!-- <div class="row mb-4">
                                <div class="col">
                                  <div class="form-check font-size-15">
                                    <input class="form-check-input" type="checkbox" id="remember-check" />
                                    <label class="form-check-label font-size-13" for="remember-check">Remember
                                      me</label>
                                  </div>
                                </div>
                              </div> -->
                              <div class="mt-4 mt-md-5">
                                <button class="btn btn-primary w-100 waves-effect waves-light position-relative" :disabled="loading" type="submit" @click.prevent="login()">
                                  Log In
                                  <i v-show="loading" class="mdi mdi-spin mdi-loading position-absolute"></i>
                                </button>
                              </div>
                            </form>

                            <!-- <div class="mt-4 pt-3 text-center">
                              <p class="text-muted mb-0">
                                Forgot Password ?
                                <router-link to="/auth/recoverpwd" class="text-primary fw-semibold">Reset
                                  here</router-link>
                              </p>
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end auth full page content -->
        </div>
        <!-- end col -->
        <div class="col-xxl-8 col-lg-8 col-md-6">
          <div class="auth-bg bg-white py-md-5 p-4 d-flex">
            <div class="bg-overlay bg-white"></div>
            <!-- end bubble effect -->
            <div class="row justify-content-center align-items-center w-100">
              <div class="col-xl-8">
                <div class="mt-4 text-center">
                  <img src="@/assets/images/login-img.png" class="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container fluid -->
  </div>
</template>
